import { defineComponent as _defineComponent } from 'vue'
import { WecouponMall } from '@tencent/wphk-components-wecoupon';
import { i18n } from '@/i18n';

export default /*#__PURE__*/_defineComponent({
  __name: 'we-coupon-mall',
  setup(__props) {


return { __sfc: true,WecouponMall, i18n }
}

})